import React from "react";
import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  AccountMovement,
  AccountMovementCashDesk,
  GetBettingsListQuery,
  GetContractQuery,
} from "../../../../API";
//import { setShowImageBg } from "../../../../features/theme/themeSlice";
import { getBettingsList } from "./query";
import DataTable, { TableColumn } from "react-data-table-component";
import { useAppSelector } from "../../../../app/hooks";
import themeSlice, {
  selectTheme,
  ThemeColor,
} from "../../../../features/theme/themeSlice";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Radio,
  Row,
  Select,
} from "antd";
import moment from "moment";
//import PrintPlacebet from "../../../../components/shared-components/PrintPlacebet";
import { getContract } from "../../../../graphql/queries";
import { createDeflate } from "zlib";
import { number } from "yup/lib/locale";
import PrintPlacebet from "../../../account/components/PrintPlacebet";

const CashBettingsList: React.FC = () => {
  const [bettingsList, setBettingsList] = useState<
    Array<AccountMovementCashDesk>
  >([]);
  const [filteredBettingsList, setFilteredBettingsList] = useState<
    Array<AccountMovementCashDesk>
  >([]);
  const [dateFilter, setDateFilter] = useState<{
    dal: moment.Moment;
    al: moment.Moment;
  } | null>(null);
  const [couponFilterInput, setCouponFilterInput] = useState<string | null>(
    null
  );
  const [couponFilter, setCouponFilter] = useState<{
    contract: string | null | undefined;
    ticketid: number;
  } | null>(null);
  const [resultFilter, setResultFilter] = useState<string | null>(null);
  const [paymentStateFilter, setPaymentStateFilter] = useState<string | null>(
    null
  );
  const [userFilter, setUsertFilter] = useState<string | null>(null);
  const [modalTicket, setModalTicket] = useState<boolean>(false);
  const [printLastTicket, setPrintlastTicket] = useState<boolean>(false);
  const [lastPlacebetMovement, setLastPlacebetMovement] =
    useState<AccountMovement | null>(null);
  const [userList, setUserList] = useState<Array<string> | null>(null);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dispatch = useDispatch();
  const { RangePicker } = DatePicker;
  useEffect(() => {}, [dateFilter]);

  useEffect(() => {
    (async () => {
      const users: Array<string> = [];
      const result: GraphQLResult<GetBettingsListQuery> = (await API.graphql({
        query: getBettingsList,
        authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        variables: {},
      })) as GraphQLResult<GetBettingsListQuery>;
      const orderedItems = result.data.getBettingsList.items.sort(
        (a: any, b: any) => {
          return a.createdAt > b.createdAt ? a : b;
        }
      );
      setBettingsList(orderedItems);
      setFilteredBettingsList(orderedItems);
      result.data.getBettingsList.items.map((b, i) => {
        if (!users.includes(b.username)) users.push(b.username);
      });
      setUserList(
        users.sort((a, b) => {
          if (a < b) return -1;
          else return 1;
        })
      );
    })();
    //dispatch(setShowImageBg(false));
  }, []);

  useEffect(() => {
    if (couponFilterInput && couponFilterInput.length === 3) {
      (async () => {
        const contract: GraphQLResult<GetContractQuery> = (await API.graphql({
          query: getContract,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {
            contractnumber: couponFilterInput.substring(0, 3),
          },
        })) as GraphQLResult<GetContractQuery>;

        setCouponFilter({
          contract: contract.data.getContract.SK,
          ticketid: 0,
        });
      })();
    } else if (couponFilterInput && couponFilterInput.length > 3) {
      setCouponFilter({
        contract: couponFilter?.contract,
        ticketid: Number(couponFilterInput.substring(3)),
      });
    }
  }, [couponFilterInput]);

  useEffect(() => {
    if (lastPlacebetMovement) {
      setPrintlastTicket(true);
      setModalTicket(true);
    }
  }, [lastPlacebetMovement]);

  const { Option } = Select;
  const intl = useIntl();
  const theme = useAppSelector(selectTheme);

  const filterFn = (m: AccountMovementCashDesk) => {
    let dateCheck = true;
    if (dateFilter) {
      const c = moment(m.createdAt);
      dateCheck = c.isBetween(dateFilter.dal, dateFilter.al);
    } else {
      dateCheck = true;
    }

    let codiceFilter = true;
    if (couponFilterInput) {
      codiceFilter =
        m.PK === `${couponFilter?.contract}#BETID#${couponFilter?.ticketid}`;
    } else codiceFilter = true;

    let lResultFilter = true;
    if (resultFilter) {
      if (m.status) {
        lResultFilter = m.status.substring(0, 1) === resultFilter;
      } else {
        lResultFilter = m.status == null;
      }
    }

    let lUserFilter = true;
    if (userFilter) {
      lUserFilter = m.username === userFilter;
    }

    let lPaymentFilter = true;
    if (paymentStateFilter) {
      if (paymentStateFilter === "P" && m.paymentStatus) {
        lPaymentFilter =
          m.paymentStatus?.substring(0, 1) === paymentStateFilter &&
          m.status?.substring(0, 1) === "W";
      } else if (paymentStateFilter === "N") {
        lPaymentFilter =
          m.paymentStatus == null && m.status?.substring(0, 1) === "W";
      } else {
        lPaymentFilter = false;
      }
    } else lPaymentFilter = true;

    return (
      codiceFilter &&
      dateCheck &&
      lResultFilter &&
      lUserFilter &&
      lPaymentFilter
    );
  };

  const columns: TableColumn<AccountMovementCashDesk>[] = [
    { name: "Coupon", selector: (row: any) => row.PK },

    {
      name: intl.formatMessage({ id: "Cashdesk" }),
      selector: (row: any) => `${row.username} - ${row.desk?.station}`,
      sortable: true,
    },

    {
      name: intl.formatMessage({ id: "typology.maiusc" }),
      selector: (row: any) => row.provider_hook_event,
      sortable: true,
    },
    {
      name: intl.formatMessage({ id: "date" }),
      cell: (row: any) => {
        return `${intl.formatDate(row.createdAt)} ${intl.formatTime(
          row.createdAt,
          {
            timeZone: tz,
          }
        )}`;
      },
      sortable: true,
      sortFunction: (a: any, b: any) => {
        return a.createdAt < b.createdAt ? 1 : -1;
      },
    },

    {
      name: intl.formatMessage({ id: "result.date" }),
      cell: (row: any) => {
        if (
          row.status &&
          (row.status.substring(0, 1) === "W" ||
            row.status.substring(0, 1) === "L")
        ) {
          const d1 = new Date(parseInt(row.status?.substring(2))).toISOString();
          const d = moment(d1);
          return `${intl.formatDate(d.toISOString())} ${intl.formatTime(
            d.toISOString()
          )}`;
        }
        return "";
      },
      sortable: true,
    },

    {
      name: intl.formatMessage({ id: "amount" }),
      cell: (row: any, index: any) => {
        if (
          row.provider_hook_event === "PLACEBET" ||
          row.provider_hook_event === "WITHDRAWALREQUEST" ||
          row.provider_hook_event === "SHOP_WITHDRAWAL" ||
          row.sign === "CR"
        )
          return intl.formatNumber(row.amount * -1, {
            style: "currency",
            currency: row.valute,
          });
        return intl.formatNumber(row.amount, {
          style: "currency",
          currency: row.valute,
        });
      },
    },
    {
      name: intl.formatMessage({ id: "status" }),

      center: true,
      cell: (row: any) => {
        if (row.status) {
          if (row.status.substring(0, 1) === "W")
            return <div className="bet-win"></div>;
          if (row.status.substring(0, 1) === "L")
            return <div className="bet-lost"></div>;
        }

        return <div className="bet-inprogress"></div>;
      },
    },
    {
      name: intl.formatMessage({ id: "win" }),
      selector: (row: any) =>
        intl.formatNumber(row.amountWinning, {
          style: "currency",
          currency: row.valute,
        }),
    },

    {
      name: intl.formatMessage({ id: "paymentStatus" }),
      center: true,
      cell: (row: any) => {
        if (row.paymentStatus) {
          if (row.paymentStatus.substring(0, 1) === "P")
            return <div className="bet-paid"></div>;
        } else return <div className="bet-nopaid"></div>;
      },
    },
    {
      name: "...",
      cell: (row: any) => {
        return (
          <Button onClick={() => setLastPlacebetMovement(Object.assign(row))}>
            <FormattedMessage id="print" />
          </Button>
        );
      },
    },
  ];
  return (
    <div className="bettings-list">
      <div className="filter">
        <Row gutter={16}>
          <Col md={4}>
            <FormattedMessage id="bet.date" />
          </Col>
          <Col md={4}>
            <FormattedMessage id="range" />
          </Col>
          <Col md={4}>
            <RangePicker
              style={{ width: "100%" }}
              onChange={(value) => {
                if (value) {
                  setDateFilter({
                    dal: moment(value[0]?.format("YYYY-MM-DD")),
                    al: moment(value[1]?.format("YYYY-MM-DD") + " 23:59"),
                  });
                }
              }}
            />
          </Col>
          <Col md={12}>&nbsp;</Col>
        </Row>
        <Row gutter={16}>
          <Col md={4}>
            <FormattedMessage id="coupon" />
          </Col>
          <Col md={4}>
            <FormattedMessage id="code" />
          </Col>
          <Col md={4}>
            <Input
              value={couponFilterInput ? couponFilterInput : ""}
              onChange={(evt) => {
                setCouponFilterInput(evt.target.value);
              }}
            />
          </Col>
          <Col md={2}>&nbsp;</Col>
          <Col md={4}>
            <FormattedMessage id="result" />
          </Col>
          <Col md={4}>
            <Select
              value={resultFilter}
              style={{ width: "100%" }}
              onChange={(evt) => {
                setResultFilter(evt);
              }}
            >
              <Option key={1} value="">
                &nbsp;
              </Option>
              <Option key={2} value="W">
                <FormattedMessage id="win" />
              </Option>
              <Option key={3} value="L">
                <FormattedMessage id="lost" />
              </Option>
              <Option key={4} value="A">
                <FormattedMessage id="pending" />
              </Option>
            </Select>
          </Col>
          <Col md={2}>&nbsp;</Col>
        </Row>
        <Row gutter={16}>
          <Col md={4}>
            <FormattedMessage id="user" />
          </Col>
          <Col md={4}>
            <FormattedMessage id="subject" />
          </Col>
          <Col md={5}>
            {userList && (
              <Select
                value={userFilter}
                onChange={(v) => {
                  setUsertFilter(v);
                }}
                style={{ width: "100%" }}
              >
                <Option key={`0-user`} value={null}>
                  &nbsp;
                </Option>
                {userList.map((u, i) => {
                  return (
                    <Option key={`${i}-user`} value={u}>
                      {u}
                    </Option>
                  );
                })}
              </Select>
            )}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={4}>
            <FormattedMessage id="payment.state" />
          </Col>
          <Col md={4}></Col>
          <Col md={6}>
            <Radio.Group
              onChange={(v) => {
                setPaymentStateFilter(v.target.value);
              }}
              value={paymentStateFilter}
            >
              <Radio value={null}>
                {" "}
                <FormattedMessage id="all" />
              </Radio>

              <Radio value="N">
                {" "}
                <FormattedMessage id="not.payed" />
              </Radio>

              <Radio value="P">
                {" "}
                <FormattedMessage id="payed" />
              </Radio>
            </Radio.Group>
          </Col>
        </Row>

        <div className="d-flex f-row filter-buttons">
          <Button
            onClick={() => {
              setDateFilter(null);
              setCouponFilter(null);
              setPaymentStateFilter(null);
              setUsertFilter(null);
              setResultFilter(null);
              setCouponFilterInput(null);
              setFilteredBettingsList(bettingsList);
            }}
          >
            <FormattedMessage id="cancel" />
          </Button>
          <Button
            onClick={() => {
              // const f = bettingsList.filter(m => {
              // 	const c = moment(m.createdAt);
              // 	console.log(c, dateFilter.dal, dateFilter.al);
              // 	if (c.isBetween(dateFilter.dal, dateFilter.al)) return true;
              // 	return false;
              // });

              const f = bettingsList.filter((m) => filterFn(m));

              setFilteredBettingsList(f);
            }}
          >
            <FormattedMessage id="next" />
          </Button>
        </div>
      </div>
      {filteredBettingsList.length > 0 && (
        <DataTable
          theme={theme.theme === ThemeColor.dark ? "dark" : "default"}
          dense
          striped
          pagination
          data={filteredBettingsList}
          columns={columns}
          defaultSortFieldId={4}
          defaultSortAsc
        />
      )}
      <Modal
        visible={modalTicket}
        title={intl.formatMessage({ id: "print.ticket" })}
        okText="Print"
        onCancel={() => {
          setModalTicket(false);
          setPrintlastTicket(false);
        }}
        onOk={() => {
          (() => {
            const divContents =
              document.getElementById("ticket-print")?.innerHTML;
            // const a = window.open('', '', 'width=800');
            // a.document.write('<html>');
            // a.document.write(`<head>
            // 	<style>
            // 		img{width:100%;margin-bottom:20px}
            // 		@page {
            // 			margin: 1cm;
            // 			size: letter;
            // 		  }

            // 	table{ border-spacing: 0; width: 100%}
            // 	table th { border: 1px solid black;background:black; color:white }
            // 	table td { border: 1px solid black; }
            // 	</style>
            // </head>`);
            // a.document.write('<body>');
            // a.document.write('<img src="images/logo.png" />');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.print();
            // setTimeout(() => {}, 700);

            function closePrint(this: any) {
              document.body.removeChild(this.__container__);
            }

            function setPrint(this: any) {
              this.contentWindow.__container__ = this;

              this.contentWindow.document.write(
                `<style>
								@media print {
									body { -webkit-print-color-adjust: exact; }
									@page { width:80mm; margin-top: 0; margin-bottom: 0; }
								}
								body {font-size: 1.5em;} table td{border: 1px solid black;padding:4px} table{border-spacing: 0;} img{width:100%; margin-bottom:10px}</style>
								<img src="/images/logo-printer.png" /><br>
								${divContents}`
              );
              this.contentWindow.onbeforeunload = closePrint;
              this.contentWindow.onafterprint = closePrint;
              this.contentWindow.focus(); // Required for IE
              setTimeout(() => {
                this.contentWindow.print();
              }, 700);
            }

            const oHiddFrame = document.createElement("iframe");
            oHiddFrame.onload = setPrint;
            oHiddFrame.style.position = "fixed";
            oHiddFrame.style.right = "0";
            oHiddFrame.style.bottom = "0";
            oHiddFrame.style.width = "0";
            oHiddFrame.style.height = "0";
            oHiddFrame.style.border = "0";

            document.body.appendChild(oHiddFrame);
          })();
        }}
      >
        <p id="ticket-print">
          {lastPlacebetMovement?.id}

          {lastPlacebetMovement && (
            <PrintPlacebet movement={lastPlacebetMovement} />
          )}
        </p>
      </Modal>
    </div>
  );
};

export default CashBettingsList;
